var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('calc-resist',{key:1}),_c('img',{attrs:{"src":require("../assets/resvalue.jpg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }